import timeTrackingService from "../api/server/timeTrackingService";
import errorHelper from "@/components/helpers/errorhelper";
export const TIMETRACKING_NAMESPACE = "timeTrackingModule";

var fakeService;
const loadFakeService = async () => {
  if (fakeService) return fakeService;
  return import(
    `../api/${process.env.VUE_APP_SERVICE_FOLDER}/timeTrackingService`
  ).then(x => {
    fakeService = x.default;
    return fakeService;
  });
};

var services = {
  api:
    (process.env.VUE_APP_SERVICE_FOLDER === "fakes" &&
      process.env.NODE_ENV === "development") ||
    process.env.NODE_ENV === "test"
      ? loadFakeService()
      : Promise.resolve(timeTrackingService)
};

const state = {
  loading: true,
  groups: [],
  hours: []
};
const mutations = {
  LOADHOURS(storeState, data) {
    storeState.hours = data;
  },
  LOADGROUPS(storeState, data) {
    storeState.groups = data;
  }
};
const actions = {
  async DELETE(context, id) {
    var api = await services.api;
    return api
      .delete(id)
      .then(function(value) {
        var found = -1;
        for (var i = 0; i < state.hours.length; i++) {
          if (state.hours[i].Id === id) found = i;
        }
        state.hours.splice(found, 1);
      })
      .catch(
        /* istanbul ignore next */ function(err) {
          errorHelper.showError(err);
        }
      );
  },
  async SAVE(context, data) {
    var api = await services.api;
    return api
      .save({
        Id: data.Id,
        CompanyGroup: {
          Id: data.CompanyGroupId
        },
        Hours: data.Hours,
        WeekEnding: data.WeekEnding
      })
      .then(function(value) {
        if (data.Id === 0) {
          data.Id = value.Id;
          context.state.hours.push(data);
        }
      })
      .catch(
        /* istanbul ignore next */ function(err) {
          errorHelper.showError(err);
        }
      );
  },
  async LOADHOURS(context) {
    var api = await services.api;
    return api
      .loadHours(context)
      .then(function(value) {
        context.commit("LOADHOURS", value);
        context.state.loading = false;
      })
      .catch(
        /* istanbul ignore next */ function(err) {
          errorHelper.showError(err);
        }
      );
  },
  async LOADGROUPS(context) {
    var api = await services.api;
    return api
      .loadGroups(context)
      .then(function(value) {
        context.commit("LOADGROUPS", value);
      })
      .catch(
        /* istanbul ignore next */ function(err) {
          errorHelper.showError(err);
        }
      );
  }
};
const getters = {
  loading: storeState => storeState.loading,
  groups: storeState => storeState.groups,
  hours: storeState => storeState.hours
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  services
};
